import React, { useEffect, useState } from "react";
import { useLoader } from "../../context/LoaderContext";
import { IBannerData, IConsentLetters, ISurgicalData } from "../../exports/interfaces";
import { dynamicFailed } from "../../hooks/useToast";
import SurgicalDomainsBanner from "../../components/surgicaldomains/SurgicalDomainsBanner";
import SurgicalDomainsDescription from "../../components/surgicaldomains/SurgicalDomainsDescription";
import {
  fetchConsentLetters,
  fetchForeHeadLift,
  fetchForeHeadLiftBanner,
} from "../../api/SurgicalDomainApi";

const ForeHeadLift = () => {
  const { setLoading } = useLoader();
  const [foreHeadLiftBanner, setForeHeadLiftBanner] = useState<IBannerData[]>(
    []
  );
  const [foreHeadLiftData, setForeHeadLiftData] = useState<ISurgicalData[]>([]);
    const [consentLetters, setConsentLetters] = useState<IConsentLetters[]>([]);

  useEffect(() => {
    setLoading(true);
    // Promise.all([fetchArchiveBanner(), fetchVideoData()])
    Promise.all([fetchForeHeadLiftBanner(), fetchForeHeadLift(), fetchConsentLetters()])
      .then(([foreHeadLiftBannerData, foreHeadLiftData, consentLettersData]) => {
        setForeHeadLiftBanner(foreHeadLiftBannerData);
        setForeHeadLiftData(foreHeadLiftData);
        setConsentLetters(consentLettersData);
        // setArchiveVideoData(videoData);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      })
      .catch(() => {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
        dynamicFailed("Server Error");
      });
  }, [setLoading]);
  return (
    <>
      <SurgicalDomainsBanner
        bannerData={foreHeadLiftBanner}
        page={"ForeHead Lift"}
      />
      <SurgicalDomainsDescription descriptionData={foreHeadLiftData} consentLetters={consentLetters} surgicalName='ForeHead_Lift'/>
    </>
  );
};

export default ForeHeadLift;
